/**
 * @param {[Date|undefined, Date|undefined]} period1
 * @param {[Date|undefined, Date|undefined]} period2
 */
export const isPeriodRangeEqual = (period1, period2) =>
    period1[0]?.getTime() === period2[0]?.getTime() && period1[1]?.getTime() === period2[1]?.getTime();

export default isPeriodRangeEqual;
